import "core-js/stable";
import "regenerator-runtime/runtime";

import React from 'react';
import { render } from 'react-dom';

import { Router, browserHistory } from 'react-router';
import routes from './routes.react';

import { initializeZendesk } from './util/zendesk';
import { initializeAnalytics, logPageView } from './analytics';

browserHistory.listen(logPageView);

initializeAnalytics();
initializeZendesk();

const app = (<Router history={browserHistory}>
  {routes}
</Router>);

render(app, document.getElementById('app-container'));
